export const CONSTANTS = {
    WELCOME_DIYA_TEXT: "Welcome to Diya Interactive!",
    PROFILE_CREATED_SUCCESSFULLY: "New profile has created successfully!",
    PROFILE_PREVIEW_TXT: "Profile Preview",
    BACK_TXT: "Back",
    PRIMARY_COLOR: "Primary color",
    SECONDARY_COLOR: "Secondary color",
    TERTIARY_COLOR: "Tertiary color",
    MAXIMUM_LENGTH_DESCRIPTION_TXT: "Maximum allowed characters: ",
    SIGN_UP_EFFORTLESSLY_TXT: "Sign up effortlessly and gain access to our curated candidate profiles for your projects.",
    FOOTER_PARA_TXT: "From Individual Specialists To Full Scale Tech Team Augmentation", 
    ENTER_EMAIL_TXT: "Enter your email",
    CONTINUE_TXT: "Continue",
    REQUEST_OTP_TXT: "Request OTP",
    NO_ACCOUNT_QUES_TXT: "No account? Contact sales team",
    SALES_DIYA_TXT: "sales.diyainteractive.com",
    COPY_RIGHT_TXT: "© Copyright 2017 - 2023 Diya Interactive, SE",
    COPY_RIGHT_FOOTER_TXT: "© 2024 by Diya Interactive AB",
    ALL_RIGHTS_RESERVED: "All copyrights reserved by Diya Interactive, A.B. Sweden, Pakistan.",
    SEE_HIRING_POLICY: "See our hiring process.",
    VIEW_PROFILE_TXT: "View profile",
    MODIFY_PROFILE_TXT: "Modify profile",
    MODIFY_EDUCATION_TXT: "Modify education",
    MODIFY_EXPERIENCE_TXT: "Modify experience",
    MODIFY_MEDIA_TXT: "Modify media",
    MODIFY_QNA:"Modify Q&A",
    DASHBOARD_TXT: "Dashboard",
    PROFILE_TXT: "Profile",
    PROFILE_DETAIL_TXT: "Profile Detail",
    QNA_TXT: "Questions and Answers",
    EXPERIENCE_HEADING_TXT: "Experience",
    EDUCATION_HEADING_TXT: "Education",
    SKILLS_HEADING_TXT: "Skillset",
    TECHSTACK_HEADING_TXT: "Tech Stack",
    RECOMMENDATIONS_TXT: "Recommendations",
    YOU_MIGHT_ALSO_LIKE_TXT: "(You might also like)",
    VIDEO_SUPPORT_TXT: "Your browser does not support the video tag.",
    MEET_TXT: "Meet",
    QUESTION_MODAL_HEADING: "Modify question & answer",
    TITLE_TXT: "Title",
    QUESTION_TXT: "Question",
    ANSWER_TXT: "Answer",
    LOCATION_TXT: "Location",
    DESCRIPTION_TXT: "Description",
    STATUS_TXT: "Status",
    OTP_SENT_TXT: "We have sent an OTP to your email address",
    ENTER_OTP_TXT: "Enter OTP",
    DIDNT_RCVD_CODE: "Didn’t receive code?",
    RESEND_OTP: "Resend OTP",
    VERIFY_TXT: "Verify",
    AVAILABILITY_IMMEDIATELY_CODE_TXT: "AVAILABLE_IMMEDIATELY",
    AVAILABLE_ON_DATE_CODE_TXT: "AVAILABLE_ON_DATE",
    NOT_AVAILABLE_CODE_TXT: "NOT_AVAILABLE",
    UNAVAILABLE_TXT: "Unavailable",
    IMMEDIATELY_TXT: "Immediately",
    ON_DATE_TXT: "On date",
    AVAILABILITY_IMMEDIATELY_TXT: "Available immediately",
    AVAILABLE_ON_DATE_TXT: "Available from",
    NOT_AVAILABLE_TXT: "Not available",
    CREATE_PROFILE: "Create a new profile",
    NAME_TXT: "Name",
    CANCEL_TXT: "Cancel",
    SAVE_TXT: "Save",
    SAVE_N_PUBLISH_TXT: "Save & Publish",
    SAVE_AS_DRAFT_TXT: "Save as Draft",
    LOGIN_TXT: "Login",
    UPGRADE_NOW_TXT: "Upgrade now",
    HOME_TXT: "Home",
    ABOUT_TXT: "About",
    SERVICES_TXT: "Services",
    CONTACT_TXT: "Contact",
    STEPS_TXT: "Steps",
    TESTIMONIALS_TXT: "Testimonials",
    SELECT_CATERGORY: "Select Category",
    SELECT_EXPERIENCE: "Select Experience",
    SELECT_STATUS: "Select Status",
    VIDEO_LINK_TXT: "Video link",
    NO_DATA_AVAILABLE: "Relevant data is not available.",
    ERROR_ADDING_PROFILE: "We are unable to add profile due to some error.",
    CHOOSE_UPLOAD_FILE_TXT: "Choose file to upload",
    SELECTED_TXT: "Selected:",
    PROVIDE_LINK_TXT: "or provide a public link here",
    ENABLED_TXT: "Enabled",
    ENABLE_TXT: "Enable",
    DISABLED_TXT: "Disabled",
    DRAFT_TXT: "Draft",
    DISABLE_TXT: "Disable",
    CATEGORY_TXT: "Category",
    SEARCH_TXT: "Search here",
    BASIC_INFO_TXT: "Basic information",
    MEDIA_TXT: "Media",
    COUNTRY_TXT: "Country",
    SELECT_TXT: "Select",
    CITY_TXT: "City",
    AVAILABLE_STATUS: "Available status",
    EXPERIENCE_YEARS: "Year of experience",
    UPDATE_PROFILE_TXT: "update my profile",
    ADD_ROW_TXT: "Add row",
    DISPLAY_NAME_TXT: "Display name",
    ADD_MORE: "Add more",
    UPLOADED_VIDEOS: "Uploaded videos",
    COMPANY_TXT: "Company",
    INSTITUTE_TXT: "Institute",
    DEGREE_TXT: "Degree",
    STARTED_ON_TXT: "Started on",
    ENDED_ON_TXT: "Ended on",
    PUBLISHED_TXT: "Published",
    PUBLISH_TXT: "Publish",
    SHOW_ON_PROFILE_TXT: "Show on profile",
    YES_TXT: "Yes",
    NO_TXT: "No",
    LOGO_TXT: "Logo",
    EXPERIENCE_TXT: "Experience",
    PROFILE_WILL_BE_DRAFT_TXT: "Profile will be saved as Draft. You can publish it later.",
    PROFILE_WILL_BE_PUBLISHED_TXT: "Are you sure you want to Publish the profile?",
    UNSUBCRIPTION_CONFIRMATION_TXT: "Are you sure you want to unsubscribe the service?",
    YOU_WILL_BE_ALLOWED_TXT: " You will be able to publish profiles till the expiry date of your subscription. Later on you can subscribe again.",
    CONFIRM_TXT: "Confirm",
    FEEDBACK_TXT: "Feedback",
    CUSTOMIZE_YOUR_DASHBOARD: "Customize your Dashboard",
    USERS_TXT: "Users",
    WELCOME_TALENTHUB_TXT: "Welcome to TalentHub!",
    NO_RESULTS_FOUND_TXT: "No results found for your query",
    NO_PROFILES_CREATED_TXT: "It looks like you haven't created any profiles yet. Get started by Creating your first profile",
    PRESENT_CANDIDATES_TXT: "Present Candidates Faster and Smarter",
    CREATE_ACCOUNT_TXT: "Create your account",
    SIGNUP_YOUR_ACCOUNT_TXT: "Or sign in to your account",
    ENTER_COMPANY_NAME_TXT: "Enter Company Name",
    PREMIUM_TXT:"Premium",
    UPGRADE_TXT: "Upgrade",
    LOGOUT_TXT: "Logout",
    UNSUBCRIBE_TXT: "Unsubscribe",
    CREATE_USER_TXT: "Create a new user",
    EDIT_USER_TXT: "Edit user",
    DELETE_USER_CONFIRMATION_TXT: "Are you sure you want to delete this user?",
    USER_UPDATED_SUCCESSFULLY_TXT: "User updated successfully",
    USER_CREATED_SUCCESSFULLY_TXT: "User created successfully",
    ERROR_UPDATING_USER_TXT: "Error updating user",
    ERROR_ADDING_USER_TXT: "Error adding user",
    FAILED_TO_LOAD_USER_DATA_TXT: "Failed to load user data",
    USER_DELETED_SUCCESSFULLY_TXT: "User deleted successfully",
    FAILED_TO_DELETE_USER_TXT: "Failed to delete user",
    ENTER_NAME_TXT: "Enter name",
    CHOOSE_FILE_TXT: "Choose file",
    CURRENT_IMAGE_TXT: "Current image",
    SELECT_ROLE_TXT: "Select Role",
    SELECT_STATUS_TXT: "Select Status",
    EDIT_TXT: "Edit",
    DELETE_TXT: "Delete",
    USER_TXT: "User",
    ROLE_TXT: "Role",
    ACTION_TXT: "Action",
    ROWS_TXT: "Rows",
    NO_USERS_FOUND_TXT: "No users found.",
    FAILED_TO_FETCH_USERS_TXT: "Failed to fetch users",
    UPLOAD_COMPANY_LOGO_TXT: "Upload your company logo",
    DRAG_N_DROP_FILE_TXT: "Drag and drop or choose your file to upload",
    LETS_SETUP_DASHBOARD_TXT: "Let’s setup your dashboard",
    FEATURES_PRODUCT_TXT: "Features product",
    START_YOUR_JOURNEY_TXT: "Start your journey",
    WHY_CHOOSE_US_TXT: "Why choose us?",
    PRICING_PACKAGES_TXT: "Pricing packages",
    LOCAL_STORAGE_KEYS: {
        USER_TOKEN_TXT: "user_token",
        USER_TXT: "user",
        PACKAGE_PLAN: "package_plan"
    },
    PAYLOAD_KEYS: {
      CREATE_UPDATE_RESOURCE_KEYS: {
        ID: "id",
        NAME: "name",
        DISPLAY_NAME: "displayName",
        TITLE: "title",
        YEARS_OF_EXPERIENCE: "yearsOfExperience",
        AVAILABLE_FROM: "availableFrom",
        AVAILABILITY_STATUS: "availabilityStatus",
        DESCRIPTION: "description",
        IMAGE_URL: "imageUrl",
        STATUS: "status",
        IMAGE_FILE: "imageFile",
        LOCATION_ID: "locationId",
        COMPANY_ID: "companyId",
        RESOURCE_TAGS: "resourceTags",
        VALUE: "value",
        RESOURCE_ID: "resourceId",
        RESOURCE_SKILLS: "resourceSkills",
        RATING: "rating",
        RESOURCE_MEDIA: "resourceMedia",
        MEDIA_FILE: "mediaFile",
        TYPE: "type",
        MEDIA_URL: "mediaUrl",
        POSITION: "position",
        RESOURCE_QUESTIONS: "resourceQuestions",
        QUESTION: "question",
        ANSWER: "answer",
        RESOURCE_EXPERIENCE: "resourceExperience",
        ORGANIZATION_NAME: "organizationName",
        STARTED_ON: "startedOn",
        ENDED_ON: "endedOn",
        RESOURCE_EDUCATION: "resourceEducations",
        INSTITUTE: "institute",
        DEGREE: "degree",
        RESOURCE_PROJECTS: "resourceProjects",
      },
      USER_SIGN_UP_KEYS: {
        EMAIL: "email",
        COMPANY_NAME: "companyName",
      },
      BRANDING_PAYLOAD_KEYS: {
        PRIMARY_COLOR: "PrimaryColor",
        SECONDARY_COLOR: "SecondaryColor",
        TERTIARY_COLOR: "TertiaryColor",
        COMPANY_LOGO: "CompanyLogo"
      }
    },
    APP_ERRORS: {
      INVALID_EMAIL_ERROR: "Invalid email format",
      ONLY_IMAGES_ERROR: "You can only add images",
      ONLY_VIDEOS_ERROR: "You can only add videos",
      EMPTY_FIELDS_ERROR: "Please fill required fields",
      ADD_URL_OR_VIDEO: "Atleast add any one file or URL to add media",
      INSTITUTE_ERROR: "Please add institute name",
      DEGREE_ERROR: "Please add degree name",
      ORGANIZATION_ERROR: "Please add company name",
      TITLE_ERROR: "Please add title",
      SELECT_AVAILABILITY_DATE: "Select availability date",
      IMAGE_SIZE_ERROR: "Image size should not exceed 5MB",
      AN_ERROR_OCCURRED: "An error occurred"
    },
    APP_DEFAULT_COLORS: {
      PRIMARY_COLOR: "#006839",
      SECONDARY_COLOR: "#00A651",
      TERTIARY_COLOR: "#3B95CB",
      BLACK_COLOR: "#000000",
      ORANGE_COLOR: "#F66A3D"
    }
  }

